import React, { useState } from "react";
import style1 from "./vediofolder/styles/lobby.css";
import style2 from "./vediofolder/styles/main.css";
import { useToast } from "@chakra-ui/react";
import { useCookies } from "react-cookie";
import ClickJoin  from "./Assets/joinSound.mp3"

function Lobby() {
  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [cookies] = useCookies(["participateEmail", "email"]);

  const email = cookies.email;
  const ownerEmail = cookies.participateEmail;
  const roomId = cookies.roomNumber;
  console.log(email, ownerEmail, "cookies");

  // let form = document.getElementById('lobby__form')

  // let displayName = sessionStorage.getItem('display_name')
  // if(displayName){
  //     form.name.value = displayName
  // }

  // form.addEventListener('submit', (e) => {
  //     e.preventDefault()


// click siund effect
  const playSound = () => {
    const sound = new Audio(ClickJoin);  // click sound
    sound.play();
  };
  // console.log(playSound,"playSound")

  //  Checks user is admin or only user and name of user and room id and enter to the rooom
  function handleAdd(val) {
    // console.log(val, "val",email,ownerEmail);
    if (val == "owner") {
      if (email.includes("malaktel")) {
        playSound()
        sessionStorage.setItem("display_name", name1); // set display name to session storage
        let inviteCode = roomId;
        if (!inviteCode) {
          inviteCode = String(Math.floor(Math.random() * 10000));
        }
        setTimeout(()=>{
          window.location = `room?room=${inviteCode}`; // redirect to room page
  
        },1000)
        
      } else {
        alert("You are not the owner of this room!");
      }
    } else {
      playSound()
      sessionStorage.setItem("display_name", name1);

      let inviteCode = roomId;
      if (!inviteCode) {
        inviteCode = String(Math.floor(Math.random() * 10000));
      }
      setTimeout(()=>{
        window.location = `room?room=${inviteCode}`;

      },1000)
     
    }
  }

  // })

  return (
    <div>
      <header id="nav" style={{ marginTop: "80px", background: "none" }}>
        <div className="nav--list">
          <a href="/lobby">
            <h3 id="logo">
              {/* <img src="./Auction.png" alt="Site Logo"/>
                    <span>Malak-Tel</span> */}
            </h3>
          </a>
        </div>

        <div id="nav__links">
          {/* <!-- <a className="nav__link" href="/">
                Lobby
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ede0e0" viewBox="0 0 24 24"><path d="M20 7.093v-5.093h-3v2.093l3 3zm4 5.907l-12-12-12 12h3v10h7v-5h4v5h7v-10h3zm-5 8h-3v-5h-8v5h-3v-10.26l7-6.912 7 6.99v10.182z"/></svg>
            </a> --> */}
          {/* <a className="nav__link" id="create__room__btn" href="/lobby">
                Create Room
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ede0e0" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"/></svg>
            </a> */}
        </div>
      </header>

      <main id="room__lobby__container" style={{ marginTop: "200px" }}>
        <div id="form__container">
          <div
            id="form__container__header"
            style={{ height: "50px", padding: "30px", color: "white" }}
          >
            <p>👋 Join Auction</p>
          </div>

          <form id="lobby__form" onSubmit={(e) => e.preventDefault()}>
            <div className="form__field__wrapper" style={{ color: "white" }}>
              <label>Your Name</label>
              <input
                type="text"
                name="name"
                required
                placeholder="Enter your display name..."
                onChange={(e) => setName1(e.target.value)}
              />
            </div>

            <div className="form__field__wrapper">
              <label style={{ color: "white" }}>Room Number</label>
              <input
                type="text"
                name="room"
                placeholder="Enter Room Number"
                onChange={(e) => setName2(e.target.value)}
                value={roomId}
                disabled
              />
            </div>

            <div className="form__field__wrapper">
              <button type="submit" onClick={() => handleAdd("user")}>
                Go to Room
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
                </svg>
              </button>
              {/* <h3 className="text-white mt-5 flex justify-center -mb-7 items-center text-base md:text-lg lg:text-lg">
                If Your our employee
                <span
                  onClick={() => handleAdd("owner")}
                  className="ml-0.5 underline cursor-pointer"
                >
                  CLICK HERE!
                </span>
              </h3> */}
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default Lobby;
